module.exports = __webpack_public_path__ + "static/media/mic_disabled_dark.dfd20183.svg";